import React, {useEffect, useRef, useState} from 'react';
import Button from '../components/Button';
import {getIdpAuthenticationUrl, getIdpAuthenticationUrlReset} from "../actions/security";
import { connect } from 'react-redux';
import {loginRoutes} from "../Routes/LoginRoute";
import Recaptcha from "./App/Recaptcha";
import {
    setLoadingSpinnerOpen,
    setLoadingSpinnerMessage
} from '../actions/loadingSpinner';

const browser = window.self;
const popupWindowWidth = {
    twitter: 400,
    facebook: 600,
    google: 400
};
const popupWindowHeight = {
    twitter: 560,
    facebook: 700,
    google: 560
};
const popupInit = {closed: true, focus: () => {}};

const SocialLoginButton = ({
    idpService,
    getIdpAuthenticationUrl,
    getIdpAuthenticationUrlUrl,
    getIdpAuthenticationUrlSuccess,
    getIdpAuthenticationUrlReset,
    forceClickRecaptcha = null,
    loginCallback,
    loadingOverride = null,
    setLoadingSpinnerOpen,
    setLoadingSpinnerMessage,
    Component = Button,
    ComponentProps = {
        fullWidth: true,
        size: "small",
        variant: "contained",
        color: "primary"
    },
    children
}) => {
    const [openWindow, setOpenWindow] = useState(false);
    const popupRef = useRef(popupInit);
    const openIntervalRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState('');


    const handleClick = (recaptchaToken) => {
        setRecaptchaToken(recaptchaToken);
        setLoading(true);
        getIdpAuthenticationUrl({
            idpService,
            redirectUri: `${window.location.origin}${loginRoutes.redirect}`
        })
        setOpenWindow(true);
    };

    const openPopup = (idpAuthUrl) => {
        if (popupRef && !popupRef.current.closed) {
            popupRef.current.focus();
            return;
        }
        const name = `social-login-${idpService}`;

        popupRef.current = browser.open(idpAuthUrl, name, [
            'popup=1',
            `width=${popupWindowWidth[idpService]}`,
            `height=${popupWindowHeight[idpService]}`,
            `top=${browser.outerHeight / 2 - popupWindowHeight[idpService] / 2}`,
            `left=${browser.outerWidth / 2 - popupWindowWidth[idpService] / 2}`
        ].join(','));

        browser.loginCallback = ({
            code, authuser, prompt, scope, oauth_token, oauth_verifier
        }) => {
            loginCallback({
                idpService,
                redirect_uri: `${window.location.origin}${loginRoutes.redirect}`,
                code,
                authuser,
                prompt,
                scope,
                oauth_token,
                oauth_verifier,
                recaptchaToken
            });
            clearInterval(openIntervalRef.current);
        }

        openIntervalRef.current = setInterval(
            () => {
                if (popupRef?.current?.closed) {
                    browser.loginCallback = () => {};
                    setLoading(false);
                    clearInterval(openIntervalRef.current);
                    setLoadingSpinnerOpen(false);
                    setLoadingSpinnerMessage('');
                }
            }, 1000
        )
    }

    useEffect(() => {

        const handleWindowFocus = () => {
            browser.loginCallback = () => {};
            setLoading(false);
            clearInterval(openIntervalRef.current);
            setLoadingSpinnerOpen(false);
            setLoadingSpinnerMessage('');
        };

        window.addEventListener('focus', handleWindowFocus);

        return () => {
            window.removeEventListener('focus', handleWindowFocus);
        };


    }, [setLoadingSpinnerOpen, setLoadingSpinnerMessage])

    useEffect(() => {
        if (loadingOverride !== null) {
            setLoading(loadingOverride);
        }
    }, [loadingOverride])

    useEffect(() => {
        if (forceClickRecaptcha) {
            handleClick(forceClickRecaptcha);
        }
        // eslint-disable-next-line
    }, [forceClickRecaptcha]);

    useEffect(() => {
        if (getIdpAuthenticationUrlSuccess && openWindow) {
            setOpenWindow(false);
            openPopup(getIdpAuthenticationUrlUrl);
            getIdpAuthenticationUrlReset();
        }
        // eslint-disable-next-line
    }, [getIdpAuthenticationUrlSuccess, openWindow, getIdpAuthenticationUrlReset, getIdpAuthenticationUrlUrl]);

    return (
        <Recaptcha
            onSubmit={handleClick}
        >
            {({submitAction}) => {
                const handleClick= (e) => {
                    setLoadingSpinnerOpen(true);
                    setLoadingSpinnerMessage('Make sure your browser allows popups')
                    submitAction(e);
                }
                return (
                    <>
                        <Component
                            {...ComponentProps}
                            loading={loading}
                            onClick={handleClick}
                            disabled={loading}
                        >
                            {children}
                        </Component>
                    </>
                );
            }}
        </Recaptcha>
    )
};


export default connect(
    (state) => ({
        getIdpAuthenticationUrlUrl: state.security.getIdpAuthenticationUrlUrl,
        getIdpAuthenticationUrlSuccess: state.security.getIdpAuthenticationUrlSuccess
    }),
    {
        getIdpAuthenticationUrl,
        getIdpAuthenticationUrlReset,
        setLoadingSpinnerOpen,
        setLoadingSpinnerMessage
    }
)(SocialLoginButton);